import React, { PureComponent, ReactNode } from 'react';
import { TempErrorWrap } from './styles';

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

class ErrorBoundary extends PureComponent<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      // eslint-disable-next-line react/no-unused-state
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <TempErrorWrap>
          <div>
            <img
              src="https://storage.googleapis.com/bexs-forex-static/images/ebury-bank-logo-black-horizontal.png"
              alt="Ebury Logo"
              title="Ebury"
            />
            <h2>We apologize, but there was an error.</h2>
            <p>
              Please try to reload the page. If the error persists, consider
              sending a message to Ebury.
            </p>
          </div>
        </TempErrorWrap>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
